module.exports = __webpack_public_path__ + "static/media/2025-Sports-Masterclass-Tablet-Banner@2x.7a8049fc.webp";